import { render, staticRenderFns } from "./EntitiesManagerForm.vue?vue&type=template&id=1953d996&"
import script from "./EntitiesManagerForm.vue?vue&type=script&lang=ts&"
export * from "./EntitiesManagerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports